module.exports = __webpack_public_path__ + "img/firefox.d4bb47e7.png";